// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2NmCU","itemTitle":"ClientEmergencyInfo_itemTitle__yKPcC","itemText":"ClientEmergencyInfo_itemText__1hHQw"};